import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core'

import { LayoutCardsGrid } from 'app/core/cms/generated/api-types'
import { explicitComputed } from 'app/utils/signal-utils'

import { CmsBlock } from '../../cms-block'
import { ContainerInfo, divideContainerSize } from '../../container-info'
import { InsertDynamicCardDirective } from '../../insert-dynamic-card.directive'
import { LayoutContainer } from '../../sections/layout-container'

@Component({
  selector: 'pai-layout-cards',
  templateUrl: './layout-cards-grid.component.html',
  styleUrls: ['./layout-cards-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [InsertDynamicCardDirective],
  providers: [
    { provide: CmsBlock, useExisting: LayoutCardsGridComponent },
    { provide: LayoutContainer, useExisting: LayoutCardsGridComponent },
  ],
  host: {
    '[style.--col-count]': 'colCount()',
  },
})
export class LayoutCardsGridComponent extends CmsBlock<LayoutCardsGrid> implements LayoutContainer {
  readonly __typename = 'LayoutCardsGrid'

  protected readonly colCount = computed(() => parseInt(this.data().cardsColumnCount?.replace('_', '') ?? '2'))

  readonly containerInfo = explicitComputed(
    [inject(LayoutContainer, { skipSelf: true }).containerInfo, this.colCount],
    (parent, colcount): ContainerInfo => {
      return {
        maxWidthAtMd: `50vw`, // always 2 cols at md
        maxWidthAtLg: divideContainerSize(parent.maxWidthAtLg, colcount),
        maxWidthAtXl: divideContainerSize(parent.maxWidthAtXl, colcount),
      }
    },
  )
}
